export const stringMapDefault = {
    collapse: "Collapse row",
    expand: "Expand row"
};
